export default __webpack_public_path__ + "static/media/img-hero5.dc10c152.png";